import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderBeforeLoginService {
  public userInitials = signal('');
  public headerLogo = signal<string | null>(null);
  public headerLogoLoaded = signal(false);
  public showViewBanner = signal(false);
  public showHeader = signal(true);
  public isCustomerLayout = signal(false);
  public kapybaraRevealed = signal(false);
  public kapybaraOpenSidebarRequest = signal(false);

  constructor() { }

  public onKapybaraHeaderClick(): void {
    this.kapybaraRevealed.set(true);
    // this.kapybaraOpenSidebarRequest.set(true);
  }

  public clearKapybaraOpenSidebarRequest(): void {
    this.kapybaraOpenSidebarRequest.set(false);
  }

  public updateUserInitials(initials: string) {
    this.userInitials.set(initials);
  }

  public updateHeaderLogo(base64Logo: string | null) {
    this.headerLogo.set(base64Logo);
    this.headerLogoLoaded.set(true);
  }

  public setViewBannerVisible(visible: boolean) {
    this.showViewBanner.set(visible);
  }

  public setHeaderVisible(visible: boolean) {
    this.showHeader.set(visible);
  }

  public setCustomerLayout(isCustomer: boolean) {
    this.isCustomerLayout.set(isCustomer);
  }
}
